import { usePlanTypeStore } from "@/stores/planTypeStore";

/**
 * Higher-order function that only executes if user has Business plan or higher
 * Shows console warning if plan requirement is not met
 * @param featureName - Name of the feature being gated
 * @param fn - Function to execute if plan allows
 * @returns Wrapped function that checks plan before execution
 */
export function withBusinessAndUp<T extends any[], R>(
  featureName: string,
  fn: (...args: T) => R
) {
  return (...args: T): R | undefined => {
    const planTypeStore = usePlanTypeStore();

    if (planTypeStore.isBusinessOrHiger) {
      return fn(...args);
    } else {
      console.warn(
        `The feature "${featureName}" is not available in your plan. Please upgrade to a Business plan or higher.`
      );
      return undefined;
    }
  };
}

/**
 * Higher-order function that only executes if user has Expansion plan or higher
 * Shows console warning if plan requirement is not met
 * @param featureName - Name of the feature being gated
 * @param fn - Function to execute if plan allows
 * @returns Wrapped function that checks plan before execution
 */
export function withExpansionAndUp<T extends any[], R>(
  featureName: string,
  fn: (...args: T) => R
) {
  return (...args: T): R | undefined => {
    const planTypeStore = usePlanTypeStore();

    if (planTypeStore.isExpansionOrHigher) {
      return fn(...args);
    } else {
      console.warn(
        `The feature "${featureName}" is not available in your plan. Please upgrade to an Expansion plan or higher.`
      );
      return undefined;
    }
  };
}
